module.exports = __webpack_public_path__ + "media/indexvideo2.48eb7117.mp4";